module.exports = __webpack_public_path__ + "img/as.eb25af6e.png";